import { render, staticRenderFns } from "./daily-goal.vue?vue&type=template&id=287c3afd&scoped=true&"
import script from "./daily-goal.vue?vue&type=script&lang=js&"
export * from "./daily-goal.vue?vue&type=script&lang=js&"
import style0 from "./daily-goal.vue?vue&type=style&index=0&id=287c3afd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287c3afd",
  null
  
)

export default component.exports